import {
  DEFAULT_REGION_LANG,
  INSTORE_DOMAIN,
  KSA_ALLOWED_URLS,
  ONLINE_PHARMACY_REQ_URL,
  VALID_REGION_LANGS,
  detectNormalBrowser,
  RE_DIRECTION_CODE
} from '@common/Utility/constants';

const redirectTo = (res, redirectUrl) => {
  if (res) {
    res.writeHead(RE_DIRECTION_CODE, { Location: redirectUrl });
    res.end();
  }
};

// eslint-disable-next-line import/prefer-default-export
export const handleRedirects = (ctx) => {
  const req = ctx?.req;
  const res = ctx?.res;
  const host = req?.headers?.host;
  const userAgent = req?.headers['user-agent'];
  const cleanUrl = ctx?.asPath?.split('?')[0] || '';
  const urlSplit = cleanUrl?.split('/') || [];
  const rawRegionLang = urlSplit.find((seg) => seg.startsWith('uae-') || seg.startsWith('sa-')) || '-';
  const regionLang = rawRegionLang.replace(/\.json$/, '');
  const incomingUrl = ctx?.asPath;
  const isBrowser = detectNormalBrowser(userAgent);

  // Handle invalid regionLang redirects
  if (isBrowser && regionLang !== '-' && !VALID_REGION_LANGS.includes(regionLang)) {
    const splitOnRegionLang = incomingUrl?.split(regionLang);
    const redirectUrl = `/${DEFAULT_REGION_LANG}${decodeURIComponent(splitOnRegionLang?.[1] || '')}`;
    redirectTo(res, redirectUrl);
    return;
  }

  // Handle missing valid regionLang in old URLs
  if ((isBrowser || incomingUrl?.includes('/waitingroom')) && regionLang === '-') {
    let redirectUrl = null;
    if (incomingUrl === '/' && DEFAULT_REGION_LANG?.includes('sa')) {
      redirectUrl = `/${DEFAULT_REGION_LANG}/online-pharmacy`;
    } else if (incomingUrl === '/' && DEFAULT_REGION_LANG?.includes('uae')) {
      redirectUrl = `/${DEFAULT_REGION_LANG}`;
    } else {
      redirectUrl = `/${DEFAULT_REGION_LANG}${decodeURIComponent(incomingUrl || '')}`;
    }
    redirectTo(res, redirectUrl);
    return;
  }

  // In-store redirection
  if (host?.includes(INSTORE_DOMAIN) && !incomingUrl?.includes(ONLINE_PHARMACY_REQ_URL)) {
    redirectTo(res, `https://${host}/online-pharmacy`);
    return;
  }

  // KSA-specific redirections
  if (regionLang?.startsWith('sa-')) {
    const cleanedPath = incomingUrl?.replace(/^\/sa-[^/]+/, '');
    const isValid = [...KSA_ALLOWED_URLS].some((allowedPath) => cleanedPath?.includes(allowedPath));

    if (!isValid) {
      redirectTo(res, `https://${host}/${regionLang}/online-pharmacy`);
    }
  }
};
